import type { IconProps } from './types';

export const ArrowCompactUpIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 12, ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8.5 8.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M4.25 7.75V0.75M4.25 0.75L0.75 4.25M4.25 0.75L7.75 4.25"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
